import { render } from "./supportIndex.vue?vue&type=template&id=cff21174"
import script from "./supportIndex.vue?vue&type=script&lang=js"
export * from "./supportIndex.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__